import { render, staticRenderFns } from "./createAboutus.vue?vue&type=template&id=3fa303c7&"
import script from "./createAboutus.vue?vue&type=script&lang=js&"
export * from "./createAboutus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports